import {Mapper} from '@s-ui/domain'

export class FromCommentsListResponseToCommentListVOMapper extends Mapper {
  constructor({
    fromCommentAnswersResponseToVOMapper,
    fromRawCommentResponseToCommentEntityMapper,
    newsCommentsCollectionValueObjectFactory
  }) {
    super()

    this._fromCommentAnswersResponseToVOMapper = fromCommentAnswersResponseToVOMapper
    this._fromRawCommentResponseToCommentEntityMapper = fromRawCommentResponseToCommentEntityMapper
    this._newsCommentsCollectionValueObjectFactory = newsCommentsCollectionValueObjectFactory
  }

  map = rawResponse => {
    const mappedComments = rawResponse.map(commentItem => {
      const {answers} = commentItem

      const answersEntities = this._fromCommentAnswersResponseToVOMapper.map(answers)

      return this._fromRawCommentResponseToCommentEntityMapper.map({...commentItem, answers: answersEntities})
    })

    return this._newsCommentsCollectionValueObjectFactory({
      comments: mappedComments
    })
  }
}
